import type { Statistics } from 'app/network/statistics';
import { FeatureFlag, isFeatureEnabled } from 'app/utils/helpers';

export const showClubName = (groups: Statistics['groups'] | undefined) => {
  return !(!groups?.length || isFeatureEnabled(FeatureFlag.justOneClub));
};
